module.exports = __webpack_public_path__ + "assets/img/btn-view-04a0b66f.png";